import { render } from "./ForecastEditRuleModal.vue?vue&type=template&id=5621799e"
import script from "./ForecastEditRuleModal.vue?vue&type=script&lang=js"
export * from "./ForecastEditRuleModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/etl/etl/outerspace-admin-2.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__